import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import UserContext from 'contexts/UserContext';
import Icon from 'components/Icon';
// import Alert from 'components/Alert';
import { Avatar } from 'components/Image';

const Course = ({ course }) => {
	// Use user's context
	const { handleUser } = useContext(UserContext);

	// Handle student's course removal
	// @event: object | native onClick event
	const onRemove = event => {
		event.preventDefault();
		handleUser({
			type: 'ON_REMOVE_COURSE_TEACHER',
			payload: {
				id: course.id
			}
		});
	};

	return (
		<div className="course">
			<div className="course__information">
				<Link to={`/courses/${course.id}`} className="course__title">
					{course.title}
					<br />
					<small>{course.subject?.title}</small>
				</Link>

				{course.teacher?.fullName && <Link to={`/users/${course.teacher.id}`} className="course__teacher">
					{course.teacher?.avatar && <Avatar src={course.teacher.avatar} alt={course.teacher.fullName} size="sm" circle />}
					<h5>{course.teacher?.fullName}</h5>
				</Link>}

				{/* {course.teacher?.fullName && <Alert
					type="warning"
					message="Pasniedzējs tiks noņemts no dotā moduļa!"
				/>} */}
			</div>

			<Icon
				icon="close"
				size="sm"
				className="course__remove"
				onClick={onRemove}
			/>
		</div>
	);
};

export default Course;